module.exports = __webpack_public_path__ + "img/service.f71afe2.svg";